
interface DwellingHighlightProps {
  title: string;
  icon: any;
  link?: string;
  data: DwellingHighlightData[]
}

interface DwellingHighlightData {
  title: string;
  value: string | number;
}

const DwellingFeatureTable: React.FC<DwellingHighlightProps> = ({ title, icon, link, data }) => {
  return (
    <div className='highlight-list flex-grow-1'>
      <div className='highlight-list__title d-flex justify-content-between'>
        <div className='d-flex align-items-center'>
          <div className='highlight-list__icon' style={{
            width: '50px',
            height: '50px',
          }}>
            {icon}
          </div>
          <h3>{title}</h3>
        </div>
        {link ? <a href={link} target="_blank">Voir l'image</a> : null}

      </div>
      {/* flex-lg-column flex-xl-row */}
      <ul className='d-flex justify-content-center overflow-x-auto'>
        {data.map((d: DwellingHighlightData, i: number) => (
          <li key={i} className='d-flex flex-column justify-content-between align-items-center w-100 border-0'>
            <span>{d.title}</span>
            <span className='text-nowrap mt-2'>{d.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default DwellingFeatureTable;
